// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"List__list"};